var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"bootstrap\"><div class=\"select2-footer\"><div class=\"margin-vertical-3x\"><p>&nbsp; Can't Find Your Co-Author?</p><button type=\"submit\" onclick=\"jQuery('input#authors-input').trigger('select2-footer-clicked');jQuery('input#work-edit-modal-coauthors-input').trigger('select2-footer-clicked');\" class=\"btn btn-primary text-bold margin-left-4x\">Add Co-Author</button></div></div></div>");;return buf.join("");
}